import {clothColors} from './clothColors';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from './topic.service';
import {MessageService} from '../shared/message.service';
import {GeneralClairvoyantComponent} from './g-clairvoyant.component';

export abstract class GeneralClairvoyantColorComponent extends GeneralClairvoyantComponent {

  isColorSet = false;
  colors: clothColors[] = [];
  solution: clothColors[];
  clickedValue: clothColors[] = [clothColors.white, clothColors.white, clothColors.white];
  isOneCardTurned = false;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    super.initValues();
    this.clickedValue = [clothColors.white, clothColors.white, clothColors.white];
    this.isOneCardTurned = false;
  }

  /**
   * Check the solution
   * If correct: generate a new exercise after a timeout
   * If not correct: display message to try again.
   */
  checkSolution() {
    if (this.compareArrays(this.clickedValue, this.solution)) {
      this.solution = [];
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      this.solved = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  /**
   * Get image of the cloths in the selected colors at the beginning of the exercise
   * @param clothType could be cap, jacket or pants
   * @param colorNumber 0 or 1. We have 2 selected colors.
   */
  getImageSrc( clothType: string, colorNumber: number) {
    return './assets/images/clothColors/' + clothType + '-' + clothColors[this.colors[colorNumber]] + '.png';
  }

  /**
   * If user click on specifc cloth type and color, this is saved. This is the solution of the user.
   * This user solution is later checked against the correct solution.
   * @param clothType could be cap, jacket or pants
   * @param colorNumber 0 or 1. We have 2 selected colors.
   */
  setClickedValue( clothType: string, colorNumber: number) {
    // check if solution is correct
    if (clothType === 'cap') {
      this.clickedValue[0] = this.colors[colorNumber];
    } else if (clothType === 'jacket') {
      this.clickedValue[1] = this.colors[colorNumber];
    } else if (clothType === 'pants') {
      this.clickedValue[2] = this.colors[colorNumber];
    }
    if (this.clickedValue[0] !== clothColors.white &&
      this.clickedValue[1] !== clothColors.white &&
      this.clickedValue[2] !== clothColors.white ) {
      this.checkSolution();
    }
  }

  isSelectedValue( clothType: string, colorNumber: number) {
    if (clothType === 'cap' && this.clickedValue[0] === this.colors[colorNumber]) {
      return true;
    }
    if (clothType === 'jacket' && this.clickedValue[1] === this.colors[colorNumber]) {
      return true;
    }
    if (clothType === 'pants' && this.clickedValue[2] === this.colors[colorNumber]) {
      return true;
    }
  }

  abstract setSolution (capShirtShortColor: clothColors[]);

  /**
   * Befor the exercise start: Set two colors for the cloths (selected by the user)
   * @param color
   */
  setColor(color: string) {
    if (color === 'red' && this.colors.indexOf(clothColors.red) === -1) {
      this.colors.push(clothColors.red);
    }
    if (color === 'blue' && this.colors.indexOf(clothColors.blue) === -1) {
      this.colors.push(clothColors.blue);
    }
    if (color === 'yellow' && this.colors.indexOf(clothColors.yellow) === -1) {
      this.colors.push(clothColors.yellow);
    }
    if (color === 'green' && this.colors.indexOf(clothColors.green) === -1) {
      this.colors.push(clothColors.green);
    }

    if (this.colors.length === 2) {
      this.isColorSet = true;
    }
  }

  /**
   * Befor the exercise start. Mark the already selected colors
   * Check if color is in the array colors, where the already selected colors are saved.
   * @param color check if this color is one of the selected colors, then return true to mark the color with a black border
   */
  isActive(color: string) {
    if (color === 'red' && this.colors.indexOf(clothColors.red) !== -1) {
      return true;
    }
    if (color === 'blue' && this.colors.indexOf(clothColors.blue) !== -1) {
      return true;
    }
    if (color === 'yellow' && this.colors.indexOf(clothColors.yellow) !== -1) {
      return true;
    }
    if (color === 'green' && this.colors.indexOf(clothColors.green) !== -1) {
      return true;
    }
  }

  /**
   * Dominant color is the first selected color -> this.colors[0]
   * The user count this color, if it even or not.
   */
  getDominantColor() {
    if (this.colors[0] === clothColors.yellow || this.colors[0] === undefined) {
      return {'background-color': clothColors[this.colors[0]]};
    } else {
      return {'background-color': clothColors[this.colors[0]], 'color': 'white'};
    }
  }

  /**
   * Change the height of the buttons, so that the exercise fit on one page. No scrolling needed.
   */
  getMaxHeight() {
    if (this.level === 1) {
      return '5.5em';
    } else {
      return '3.8em';
    }
  }
}
